
import { WEEK_MOMENTS, checkDay, checkHour } from '../deleteOutHoursDRP'


export function SpanishVersionDos() {
  
  const $modalInSpanish = document.querySelector('.custom-budget')
  const $modalInEnglish = document.querySelector('.custom-budget--en')
  const $modalInDeu = document.querySelector('.custom-budget--de')
  const $modalInFr = document.querySelector('.custom-budget--fr')
//   const $explainMsgPhone = document.querySelector('.custom-budget__msg')
//   const $phoneInput = $form.querySelector('input[name="telefono"]')

  if ($modalInSpanish !== null && $modalInEnglish === null && $modalInDeu === null && $modalInFr === null) {    
    // Recogemos el select de la modal que esta en D1C y lo eliminamos.
    const callDateSelectWrap = document.getElementById('call_date-wrap')
    callDateSelectWrap?.remove()
    
  }
}
